<div class="dx-route-not-found-report">
  <div class="dx-route-not-found-report__form dx-route-not-found-report__form--centered">
    <!-- Заголовок формы -->
    <!-- <div class="dx-route-not-found-report__form_head"></div> -->

    <!-- Основное тело формы с полями -->
    <div class="dx-route-not-found-report__form_body">
      <img class="dx-route-not-found-report__form_logo" [src]="'assets/img/dx-img/dx-navigation/route-not-found.svg'">
      <h3 class="dx-route-not-found-report__form_subtitle">{{message}}</h3>
    </div>

    <div class="dx-route-not-found-report__form_footer">
      <button class="dx-route-not-found-report__btn dx-route-not-found-report__btn--submit"
              (click)="onSendErrorReport()">
        Отправить отчет в техподдержку
      </button>
    </div>
  </div>
</div>
